// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "resource".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { appointmentColorValues } from '@borradh-workspace/labels';
/** Response atom for the "resource" table (1:1 with a DB row, on the wire). */
export const resourceAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    categoryId: z.string(),
    locationId: z.string().nullable(),
    name: z.string(),
    description: z.string().nullable(),
    color: z.enum(appointmentColorValues).nullable(),
    photo: z.string().nullable(),
    capacity: z.number(),
    specs: z.unknown().nullable(),
    workingHours: z.unknown().nullable(),
    sortOrder: z.number(),
    isActive: z.boolean(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    deletedAt: z.string().datetime().nullable(),
});
//# sourceMappingURL=resource.js.map